import type { ReactNode } from 'react';

import { twMerge } from 'tailwind-merge';

import { Text } from '@/_components';

export function ImageTextHeader({
  imageSlot = null,
  primarySlot = null,
  secondarySlot = null,
  tertiarySlot = null,
  className = '',
}: {
  imageSlot?: ReactNode;
  primarySlot?: ReactNode;
  secondarySlot?: ReactNode;
  tertiarySlot?: ReactNode;
  className?: string;
}) {
  return (
    <>
      {imageSlot}
      <div
        className={twMerge(
          'flex flex-col items-center justify-center text-center md:items-start md:text-left',
          className
        )}
      >
        <Text as="h5" className="text-accent mt-2 dark:text-white">
          {primarySlot}
        </Text>
        {secondarySlot}
        {tertiarySlot}
      </div>
    </>
  );
}
